import _classCallCheck from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _JSXStyle from "styled-jsx/style";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 *
 * NProgress
 *
 */
import React from "react";
import NProgress from "nprogress";
import Router from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";

// import styled from 'styled-components';

/* eslint-disable react/prefer-stateless-function */
var NextNProgress = /*#__PURE__*/function (_React$Component) {
  _inherits(NextNProgress, _React$Component);

  var _super = _createSuper(NextNProgress);

  function NextNProgress() {
    var _this;

    _classCallCheck(this, NextNProgress);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "timer", null);

    _defineProperty(_assertThisInitialized(_this), "routeChangeStart", function () {
      NProgress.set(_this.props.startPosition);
      NProgress.start();
    });

    _defineProperty(_assertThisInitialized(_this), "routeChangeEnd", function () {
      clearTimeout(_this.timer);
      _this.timer = setTimeout(function () {
        NProgress.done(true);
      }, _this.props.stopDelayMs);
    });

    return _this;
  }

  _createClass(NextNProgress, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          height = _this$props.height;
      return /*#__PURE__*/_jsx(_JSXStyle, {
        id: "1702795343",
        dynamic: [color, height, color, color, color, color],
        children: ["#nprogress{pointer-events:none;}", "#nprogress .bar{background:".concat(color, ";position:fixed;z-index:9999;top:0;left:0;width:100%;height:").concat(height, "px;}"), "#nprogress .peg{display:block;position:absolute;right:0px;width:100px;height:100%;box-shadow:0 0 10px ".concat(color, ",0 0 5px ").concat(color, ";opacity:1;-webkit-transform:rotate(3deg) translate(0px,-4px);-ms-transform:rotate(3deg) translate(0px,-4px);-webkit-transform:rotate(3deg) translate(0px,-4px);-ms-transform:rotate(3deg) translate(0px,-4px);transform:rotate(3deg) translate(0px,-4px);}"), "#nprogress .spinner{display:block;position:fixed;z-index:1031;top:15px;right:15px;}", "#nprogress .spinner-icon{width:18px;height:18px;box-sizing:border-box;border:solid 2px transparent;border-top-color:".concat(color, ";border-left-color:").concat(color, ";border-radius:50%;-webkit-animation:nprogresss-spinner 400ms linear infinite;-webkit-animation:nprogress-spinner 400ms linear infinite;animation:nprogress-spinner 400ms linear infinite;}"), ".nprogress-custom-parent{overflow:hidden;position:relative;}", ".nprogress-custom-parent #nprogress .spinner,.nprogress-custom-parent #nprogress .bar{position:absolute;}", "@-webkit-keyframes nprogress-spinner{0%{-webkit-transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);}}", "@-webkit-keyframes nprogress-spinner{0%{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}", "@keyframes nprogress-spinner{0%{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}"]
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var options = this.props.options;

      if (options) {
        NProgress.configure(options);
      }

      Router.events.on("routeChangeStart", this.routeChangeStart);
      Router.events.on("routeChangeComplete", this.routeChangeEnd);
      Router.events.on("routeChangeError", this.routeChangeEnd);
    }
  }]);

  return NextNProgress;
}(React.Component);

_defineProperty(NextNProgress, "defaultProps", {
  color: "#29D",
  startPosition: 0.3,
  stopDelayMs: 200,
  height: 3
});

export default NextNProgress;